markMutationResult